(() => {
  if (window.__orlenaEventTrackingLoaded) return;
  window.__orlenaEventTrackingLoaded = true;

  const sent = new Set();
  const pagePath = window.location.pathname;
  const sameSitePath = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url.pathname : '';
    } catch (error) {
      return '';
    }
  };
  const cleanText = (value = '') => value.replace(/\s+/g, ' ').trim().slice(0, 120);
  const openAiAdsEvents = {
    quiz_start: 'lead_created',
    product_click: 'contents_viewed',
    add_to_cart: 'items_added',
    sign_up: 'registration_completed',
  };

  const productContent = (params = {}) => {
    const metaProduct = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    const selectedVariant = metaProduct && Array.isArray(metaProduct.variants)
      ? metaProduct.variants.find((variant) => String(variant.id) === String(new URLSearchParams(window.location.search).get('variant')))
        || metaProduct.variants[0]
      : null;
    const amount = Number(params.amount || selectedVariant?.price || metaProduct?.price || 0) || undefined;
    return {
      id: String(params.variant_id || params.product_id || selectedVariant?.id || metaProduct?.id || params.destination_path || pagePath),
      name: cleanText(params.product_name || metaProduct?.title || document.querySelector('h1')?.textContent || params.link_text || document.title),
      content_type: 'product',
      quantity: Number(params.quantity || 1),
      amount,
      currency: params.currency || window.Shopify?.currency?.active || 'USD',
    };
  };

  const sendOpenAiAdsEvent = (name, params = {}) => {
    const eventName = openAiAdsEvents[name];
    if (!eventName || typeof window.oaiq !== 'function') return;

    if (eventName === 'items_added' || eventName === 'contents_viewed') {
      const content = productContent(params);
      const payload = {
        type: 'contents',
        contents: [content],
        currency: content.currency,
      };
      if (content.amount) payload.amount = content.amount;
      window.oaiq('measure', eventName, payload);
      return;
    }

    window.oaiq('measure', eventName, { type: 'customer_action' });
  };
  const sendEvent = (name, params = {}, onceKey = '') => {
    const key = onceKey || `${name}:${params.destination_path || params.form_type || pagePath}`;
    if (sent.has(key)) return;
    sent.add(key);

    const payload = {
      event_category: 'orlena_engagement',
      page_path: pagePath,
      transport_type: 'beacon',
      ...params,
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    }

    sendOpenAiAdsEvent(name, payload);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    const destinationPath = sameSitePath(link.getAttribute('href'));
    if (!destinationPath) return;

    const params = {
      destination_path: destinationPath,
      link_text: cleanText(link.textContent || link.getAttribute('aria-label') || ''),
    };

    if (destinationPath === '/pages/protocol-quiz') {
      sendEvent('quiz_start', params, 'quiz_start:protocol-quiz');
      return;
    }

    if (destinationPath.includes('/products/')) {
      sendEvent('product_click', params);
      return;
    }

    if (destinationPath.includes('/collections/')) {
      sendEvent('collection_click', params);
      return;
    }

    if (destinationPath.includes('protocol') || /protocol/i.test(params.link_text)) {
      const eventName = pagePath === '/pages/protocol-quiz' ? 'quiz_complete' : 'protocol_click';
      sendEvent(eventName, params, `${eventName}:${destinationPath}`);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;

    const actionPath = sameSitePath(form.getAttribute('action') || '');
    const formType = form.querySelector('input[name="form_type"]')?.value || '';

    if (actionPath.includes('/cart/add')) {
      sendEvent('add_to_cart', { form_type: 'cart_add' }, `add_to_cart:${pagePath}`);
      return;
    }

    const hasEmail = Boolean(form.querySelector('input[type="email"], input[name="contact[email]"], input[name="email"]'));
    if (formType === 'customer' || hasEmail) {
      sendEvent('sign_up', { form_type: formType || 'email' }, `sign_up:${pagePath}:${form.id || form.className || 'form'}`);
    }
  }, true);

  const referrerPath = sameSitePath(document.referrer || '');
  const isProtocolResult = pagePath.includes('/pages/')
    && pagePath !== '/pages/protocol-quiz'
    && pagePath !== '/pages/protocols'
    && (pagePath.includes('protocol') || pagePath.includes('result'));

  if (isProtocolResult && referrerPath === '/pages/protocol-quiz') {
    sendEvent('quiz_complete', { destination_path: pagePath }, `quiz_complete:${pagePath}`);
  }
})();
